module.exports = __webpack_public_path__ + "static/sport/gif-pc.0585eb2.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new-sport/gif-pc.gif
// module id = lSTN
// module chunks = 0